<template>
  <section class="invoice-add-wrapper">
    <b-row class="invoice-add">
      <!-- Col: Left (Invoice Container) -->

      <b-col cols="12" xl="9" md="8">
        <validation-observer ref="quote">
          <b-form @submit.prevent>
            <b-card no-body class="invoice-preview-card">
              <!-- Header -->
              <b-card-body class="invoice-padding pb-0">
                <div class="row align-items-center mb-2">
                  <div class="col-md-1">
                    <Logo />
                  </div>
                  <div class="col-9">
                    <div class="">
                      <CompanyName />
                    </div>
                    <div class="">
                      <Address />
                    </div>
                  </div>
                </div>
              </b-card-body>

              <!-- Spacer -->
              <hr class="invoice-spacing" />

              <!-- Invoice Client & Payment Details -->
              <b-card-body class="invoice-padding pt-0">
                <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                  <div class="col-md-6">
                    <h4 class="mb-1">Quote To:</h4>

                    <ClientAddress :client="whenSelected" />



                  </div>
                  <!-- Header: Right Content -->
                  <div class="invoice-number-date mt-md-0 mt-2">
                    <div class="d-flex align-items-center justify-content-md-between mb-1">
                      <h4 class="invoice-title">Quotation:</h4>
                      <b-input-group class="input-group-merge invoice-edit-input-group disabled">
                        <b-input-group-prepend is-text>
                          <feather-icon icon="HashIcon" />
                        </b-input-group-prepend>
                        <b-form-input id="invoice-data-id" v-model="quotationId.quotationNo" disabled />
                      </b-input-group>
                    </div>
                    <div class="d-flex align-items-center justify-content-md-between my-2">
                      <span class="title">Date:</span>
                      <flat-pickr v-model="createdOn" class="form-control invoice-edit-input" :config="{
                        minDate: createdOn,
                      }" />
                    </div>

                    <div class="d-flex align-items-center justify-content-md-between">
                      <validation-provider rules="required" v-slot="{ errors }" name="Due Date" vid="Due Date">
                        <div class="d-flex">
                          <span class="title">Due Date:</span>
                          <div>
                            <flat-pickr v-model="dueDate" class="form-control invoice-edit-input"
                              :config="{ minDate: createdOn }" />
                            <small v-if="errors.length" class="text-danger">{{
                              errors[0]
                            }}</small>
                          </div>
                        </div>
                      </validation-provider>
                    </div>
                    <div class="d-flex align-items-center justify-content-md-between mt-2">
                      <!-- Currency Label -->
                      <span class="title">Currency:</span>
                      <b-form-input class="invoice-edit-input" id="invoice-data-id" v-model="quotationId.currency"
                        disabled />
                    </div>

                    <div class="d-flex align-items-center justify-content-md-between mt-2">
                      <!-- Rate Label -->
                      <span class="title">Exchange Rate:</span>
                      <b-form-input class="invoice-edit-input" id="invoice-data-id" v-model="quotationId.rate"
                        disabled />
                    </div>

                    <br />
                    <div class="d-flex align-items-center">
                      <div class="d-flex align-items-center">
                        <span class="title"> Priority*</span>
                        <validation-provider rules="required" v-slot="{ errors }" name="Priority" vid="priority">

                          <b-form-select :options="optionPriority" v-model="priority" @change="handlePriorityChange" />
                          <small v-if="errors.length" class="text-danger">{{
                            errors[0]
                          }}</small>
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                </div>
              </b-card-body>

              <!-- Items Section -->
              <b-card-body class="invoice-padding">
                <div ref="form" class="repeater-form" :style="{ height: trHeight }">
                  <b-row v-for="(item, index) in invoiceData.items" :key="index" ref="row" class="pb-2">
                    <!-- Item Form -->
                    <!-- ? This will be in loop => So consider below markup for single item -->
                    <b-col cols="12">
                      <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                      <!-- Form Input Fields OR content inside bordered area  -->
                      <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                      <div class="d-flex border rounded">
                        <div>
                          <b-row class="flex-grow-1 px-2 pt-2">
                            <!-- Single Item Form Headers -->
                            <b-col cols="12" lg="6">
                              <label class="static-label">Items*</label>
                              <div v-if="optionsProduct.length === 0" class="d-flex justify-content-center">
                                <b-spinner variant="primary"></b-spinner>
                              </div>
                              <div v-else>
                                <validation-provider rules="required" v-slot="{ errors }" name="Item"
                                  :vid="`Item_${index}`">
                                  <v-select v-model="item.id" :options="optionsProduct" label="itemTitle"
                                    :clearable="false" :searchable="true" class="item-selector-title"
                                    placeholder="Select Item" @input="
                                      (val) =>
                                        updateItemForm(
                                          index,
                                          val,
                                          MainDiscount,
                                          MaindiscountType
                                        )
                                    ">
                                    <template #option="{
                                      itemTitle,
                                      categoryName,
                                      subCategoryName,
                                    }">
                                      <div style="
                                          display: flex;
                                          flex-direction: column;
                                        ">
                                        <span>{{ itemTitle }}</span>
                                        <span>{{ categoryName || "-" }} :
                                          {{ subCategoryName || "-" }}</span>
                                      </div>
                                    </template>
                                  </v-select>

                                  <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                              </div>
                            </b-col>
                            <!-- <b-col cols="12" lg="2">
                              <span class="d-inline d-lg-none">Cost Price</span>
                              <validation-provider
                                rules="required|min_value:0"
                                v-slot="{ errors }"
                                name="Cost Price"
                                :vid="`CostPrice_${index}`"
                              >
                                <b-form-input
                                  v-model="item.purchase"
                                  type="number"
                                  @input="updateItemCost(index)"
                                />
                                <small
                                  v-if="errors.length"
                                  class="text-danger"
                                  >{{ errors[0] }}</small
                                >
                              </validation-provider>
                            </b-col> -->
                            <b-col cols="12" lg="2">
                              <label class="static-label">Unit Price ({{ currencySymbol }})*</label>
                              <b-form-input v-model="item.cost" type="number" class="mb-2"
                                @keypress="allowOnlyNumbers($event)" @input="sanitizeInput('cost')" />
                            </b-col>

                            <b-col cols="12" lg="2" v-if="vat">
                              <label class="static-label"> VAT (%)</label>
                              <!-- {{ item }} -->
                              <b-form-input v-model="item.tax" type="number" class="mb-2"
                                @keypress="allowOnlyNumbers($event)" @input="sanitizeInput('tax')" />
                            </b-col>

                            <b-col cols="12" lg="2">
                              <div class="d-flex align-items-center justify-content-between">
                                <div class="flex-grow-1">
                                  <label class="static-label">Qty*</label>
                                  <validation-provider rules="required|min_value:0.00001" v-slot="{ errors }"
                                    name="Quantity" :vid="`Quantity_${index}`">
                                    <b-form-input v-model="item.qty" type="number" class="mb-2"
                                      @keypress="allowOnlyNumbers($event)" @input="sanitizeInput('qty')" />
                                    <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
                                  </validation-provider>
                                </div>
                              </div>
                              <div class="mb-1">
                                <b-button variant="danger" size="sm" class="mt-2" @click="removeItem(index)">
                                  Remove
                                </b-button>
                              </div>
                            </b-col>

                            <b-col cols="12" lg="12">
                              <span class="d-inline d-lg-none">Description</span>
                              <b-form-textarea v-model="item.description" class="mb-2 mb-lg-0" />
                            </b-col>
                          </b-row>
                          <b-row class="flex-grow-1 p-2"> </b-row>
                          <hr />
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm" variant="primary"
                  @click="addNewItemInItemForm">
                  Add Item
                </b-button>
              </b-card-body>

              <!-- Invoice Description: Total -->
              <b-card-body class="invoice-padding pb-0">
                <b-row>
                  <!-- Col: Sales Persion -->
                  <b-col cols="12" md="4" class="mt-md-0 mt-3 d-flex align-items-center" order="2" order-md="1">
                    <div class="w-100">
                      <span for="invoice-data-sales-person" class="text-nowrap mr-50">Sales Person:</span>
                      <validation-provider rules="required" v-slot="{ errors }" name="Sales Person" vid="Sales Person">
                        <v-select v-model="salesPersonId" :options="optionsSalesPerson" label="text"
                          :reduce="option => option.value" :clearable="false" :searchable="true"
                          placeholder="Select Sales Person">
                          <template #option="{ text }">
                            <div class="customer-option" v-b-tooltip.hover :title="text">
                              {{ text }}
                            </div>
                          </template>

                          <template #selected-option="{ text }">
                            <div class="selected-customer" v-b-tooltip.hover :title="text">
                              {{ text }}
                            </div>
                          </template>
                        </v-select>


                        <small v-if="errors.length" class="text-danger">{{
                          errors[0]
                        }}</small>

                      </validation-provider>
                    </div>
                  </b-col>

                  <!-- Col: Total -->

                  <b-col cols="12" md="8" class="mt-md-6 d-flex justify-content-end" order="1" order-md="2">
                    <div class="invoice-total-wrapper">
                      <b-row>
                        <b-col>
                          <!-- <b-form-select
                            id="invoice-discount-type"
                            v-model="MaindiscountType"
                            :options="discountTypeOptions"
                          /> -->
                          Discount %
                        </b-col>
                        <b-col>
                          <validation-provider :rules="`min_value:0|max_value:${maxDiscountValue}`" v-slot="{ errors }"
                            name="Discount" :vid="`Discount`">
                            <b-form-input id="invoice-discount-value" v-model="MainDiscount" type="number"
                              :placeholder="discountPlaceholder" @blur="ensureMainDiscountNotNull" />
                            <small v-if="errors.length" class="text-danger">{{
                              errors[0]
                            }}</small>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <div class="invoice-total-item mt-1">
                        <p class="invoice-total-title">Discount:</p>
                        <p class="invoice-total-amount">
                          {{ currencySymbol }}
                          {{ this.discountTotal.toFixed(2) }}
                        </p>
                      </div>
                      <div class="invoice-total-item">
                        <p class="invoice-total-title">Subtotal:</p>
                        <p class="invoice-total-amount">
                          {{ currencySymbol }} {{ subTotal.toFixed(2) }}
                        </p>
                      </div>

                      <div class="invoice-total-item" v-if="vat">
                        <p class="invoice-total-title">VAT:</p>
                        <p class="invoice-total-amount">
                          {{ currencySymbol }} {{ VATtotal.toFixed(2) }}
                        </p>
                      </div>

                      <!-- <div class="invoice-total-item">
                        <p class="invoice-total-title">
                          Amount Before Discount:
                        </p>
                        <p class="invoice-total-amount">
                          Rs
                          {{
                            (
                              parseFloat(subTotalAmount) + parseFloat(salesTax)
                            ).toFixed(2)
                          }}
                        </p>
                      </div> -->

                      <hr class="my-50" />
                      <div class="invoice-total-item">
                        <p class="invoice-total-title">Total:</p>
                        <p class="invoice-total-amount">
                          {{ currencySymbol }}{{ finalTotal }}
                        </p>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-card-body>

              <!-- Spacer -->
              <hr class="invoice-spacing" />

              <!-- Note -->
              <b-card-body class="invoice-padding pt-0">
                <span class="font-weight-bold">Note: </span>
                <b-form-textarea v-model="note" />
              </b-card-body>
            </b-card>
          </b-form>
        </validation-observer>
      </b-col>

      <!-- Right Col: Card -->
      <b-col cols="12" md="4" xl="3" class="invoice-actions mt-md-0 mt-2">
        <!-- Action Buttons -->
        <b-card>
          <b-button class="mb-1" v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" block
            @click="handleDocBtn(quotationId.id)">
            <b-spinner small v-if="loading"> </b-spinner>
            Documents
          </b-button>

          <b-col md="3" class="d-flex justify-content-end">
            <b-modal ref="modal-view-quote-document" id="modal-view-quote-document" ok-only ok-title="View" centered
              size="lg" title="View Quote Documents" :hide-footer="true">
              <DocumentUpload @deleteFile="deleteFile" @downloadFile="downloadFile" @uploadFiles="uploadFiles"
                :documentDetails="documentDetails" />
            </b-modal>
          </b-col>
          <!-- Button: Print -->
          <b-button v-if="quotationId.status != 3" v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary"
            block @click="updateQuotation()">
            <b-spinner small v-if="loading"> </b-spinner>
            Update
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import Logo from "@core/layouts/components/Logo.vue";
import Address from "@core/layouts/components/Address.vue";
import CompanyName from "@core/layouts/components/CompanyName.vue";
import ClientAddress from "@/@core/layouts/components/ClientAddress.vue";


import { ref, onUnmounted } from "@vue/composition-api";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";


import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

import { mapActions, mapGetters } from "vuex";
import { CurrencySymbols } from "@/libs/defaultList";

import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  VBToggle,
  BFormSelect,

  BSpinner,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "@/libs/customValidation";
import DocumentUpload from "@/views/component/DocumentUpload.vue";
import {
  deleteQuotationDocument,
  uploadQuotationMultipleDocuments,
  uploadQuotationDocument,
  downloadQuotationDocument,
} from "@/store/quotation/services";
import {
  customSwal,
  customError,
  customLoader,
  fnSortingDropdown,
} from "@/libs/customFn";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BFormSelect,
    BCardText,
    BForm,
    BFormGroup,
    BSpinner,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    flatPickr,
    vSelect,
    Logo,
    CompanyName,
    ClientAddress,
    Address,
    ValidationProvider,
    ValidationObserver,
    DocumentUpload,
  },
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  data() {
    return {
      intSubTotal: 0,
      vat: JSON.parse(localStorage.getItem("userData")).vat,
      iniDiscountTotal: 0,
      MaindiscountType: 0,
      MainDiscount: 0,
      id: this.$route.params.id,
      optionsCustomer: [],
      whenSelected: [],
      optionsProduct: [],
      optionsSalesPerson: [],
      salesPersonId: "",
      createdOn: "",
      leadClientId: "",
      orderType: "",
      dueDate: "",
      rate: "",
      note: "",
      discountPlaceholder: "Input discount %",
      tax: 0,
      currencySymbol: "Rs",
      discountTypeOptions: [
        { value: 0, text: "Percentage" },
        { value: 1, text: "Value" },
      ],
      priority: "",
      optionPriority: [
        { value: "Low", text: "LOW" },
        { value: "Medium", text: "MEDIUM" },
        { value: "High", text: "HIGH" },
      ],
      maxDiscountValue: 100,
      configDue: {
        wrap: {
          wrap: true,

          minDate: new Date(),
        },
      },
      documentDetails: {
        isDelete: false,
        documentList: [],
      },
    };
  },
  mixins: [heightTransition],
  mounted() {
    this.initTrHeight();
    this.populateSalesPersonOptions();
  },

  computed: {
    discountTotal() {
      let mainDiscount = Number(this.MainDiscount);

      if (this.MaindiscountType === 0) {
        if (mainDiscount == 0) return 0;

        return (mainDiscount / 100) * this.totalCost;
      } else {
        return mainDiscount;
      }
    },
    subTotal() {
      return this.totalCost - this.discountTotal;
    },
    VATtotal() {
      return this.salesTax;
    },
    finalTotal() {
      let total = this.subTotal + this.VATtotal;
      return total.toFixed(2);
    },
    mainDiscountRate() {
      let mainDiscount = Number(this.MainDiscount);
      return mainDiscount / 100;
    },
    ...mapGetters("quotationModule", {
      quotationId: "quotationId",
      loading: "loading",
      documents: "documents",
      file: "file",
    }),
    ...mapGetters("customerModule", {
      CustomerList: "customers",
      custId: "custId",
      loading: "loading",
    }),
    ...mapGetters("productModule", {
      ProductList: "product",
      loading: "loading",
    }),
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),

    ...mapGetters("leadModule", {
      leadList: "leads",
      loading: "loading",
    }),
    ...mapGetters("leadModule", {
      leadList: "leads",
      leadId: "leadId",
      loadingCustomer: "loading",
    }),
    totalCost() {
      let total = 0;
      this.invoiceData.items.forEach((item) => {
        total += item.cost * item.qty;
      });
      if (isNaN(parseFloat(total.toFixed(2)))) {
        return 0;
      }
      return parseFloat(total.toFixed(2));
    },

    salesTax() {
      let total = 0;

      this.invoiceData.items.forEach((item) => {
        let discountAmount = item.cost * this.mainDiscountRate;
        let discountedPrice = item.cost - discountAmount;
        let prodsalesTax = discountedPrice * (parseFloat(item.tax || 0) / 100);
        console.log("item", item);
        total += prodsalesTax * item.qty;
      });

      let totalsalesTax = parseFloat(total.toFixed(2));
      console.log("totalsalesTax", totalsalesTax);

      if (isNaN(totalsalesTax)) {
        return 0;
      }

      console.log("isvaaaaaaaaaaaaaaaaaat", this.vat);
      if (this.vat) {
        return totalsalesTax;
      } else {
        return 0;
      }

      return totalsalesTax;
    },
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    allowOnlyNumbers(event) {
  const charCode = event.which ? event.which : event.keyCode;
  const inputValue = event.target.value;

  // Allow: backspace (8), delete (46 for '.'), tab (9), arrows (37–40)
  if (
    (charCode < 48 || charCode > 57) &&  // not 0–9
    charCode !== 46 &&                   // not '.'
    charCode !== 8 &&                    // not backspace
    charCode !== 9 &&                    // not tab
    (charCode < 37 || charCode > 40)     // not arrows
  ) {
    event.preventDefault();
    return;
  }

  // Prevent multiple dots
  if (charCode === 46 && inputValue.includes('.')) {
    event.preventDefault();
    return;
  }

  // Prevent more than 5 digits after the decimal point
  const dotIndex = inputValue.indexOf('.');
  if (dotIndex !== -1) {
    const decimals = inputValue.substring(dotIndex + 1);
    if (decimals.length >= 5 && charCode >= 48 && charCode <= 57) {
      event.preventDefault();
      return;
    }
  }
},

sanitizeInput(field) {
  let value = this.item[field] ? this.item[field].toString() : '';

  // Remove non-numeric chars except dot
  value = value.replace(/[^0-9.]/g, '');

  // Limit to 1 dot and 5 decimals
  const parts = value.split('.');
  if (parts.length > 2) parts.splice(2); // only one dot
  if (parts[1]) parts[1] = parts[1].slice(0, 5);

  const sanitized = parts.join('.');
  let num = sanitized ? parseFloat(sanitized) : 0;

  // Enforce min 0.00001 if >0 but less than min
  if (num > 0 && num < 0.00001) num = 0.00001;

  this.item[field] = num;
}
    ,
    ...mapActions("customerModule", [
      "getCustomersListAction",
      "getCustomersByIDAction",
    ]),
    ...mapActions("leadModule", ["getLeadListAction", "getLeadByIDAction"]),
    ...mapActions("productModule", ["getProductListAction"]),
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    ...mapActions("quotationModule", [
      "getQuotationByIdAction",
      "updateQuotationsAction",
      "getQuotationDocumentListAction",
    ]),

    async handleDocBtn(referenceId) {
      try {
        console.log("handleDocBtn", referenceId);
        await this.getQuotationDocumentListAction(referenceId);
        if (this.documents.length > 0) {
          this.documentDetails.documentList = this.documents;
          this.documentDetails.isDelete = true;
        }
        this.$refs["modal-view-quote-document"].show();
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    },

    populateSalesPersonOptions() {
      this.optionsSalesPerson = this.SalesPersonList.map(v => ({
        value: v.id,
        text: `${v.firstName} ${v.lastName}`
      }))
    },

    async downloadFile(downloadById, fileName) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document is being prepared for download",
        onOpen: () => {
          loader.showLoading();
        },
        allowOutsideClick: () => !loader.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      try {
        const response = await downloadQuotationDocument(downloadById);
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type:
              response.headers["content-type"] || "application/octet-stream",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); // Use the provided fileName parameter directly
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up DOM by removing the link element after clicking
        window.URL.revokeObjectURL(url); // Free up memory by releasing object URL

        loader.close();
      } catch (error) {
        console.error("Download failed:", error);
        loader.close();
        this.error("Failed to download the file. Please try again."); // Updated error message for better clarity
      }
    },
    async uploadFiles(selectedFiles) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document(s) is being added",
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });
      const referenceId = this.quotationId.id;

      const maxSize = 20 * 1024 * 1024;
      if (this.selectedFiles && this.selectedFiles.size > maxSize) {
        alert("File size exceeds 20 MB limit. Please choose a smaller file.");
        this.submitting = false;
        return;
      }

      if (selectedFiles.length > 1) {
        await uploadQuotationMultipleDocuments(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal("Your file(s) have been successfully uploaded.");
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      } else if (selectedFiles.length < 2) {
        await uploadQuotationDocument(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal("Your file(s) have been successfully uploaded.");
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      }

      await this.getQuotationDocumentListAction(referenceId);
      this.documentDetails.documentList = this.documents;
      this.documentDetails.isDelete = true;

      this.$nextTick(() => {
        this.$bvModal.show("modal-view-quote-document");
      });
    },
    async deleteFile(deleteById) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document is being deleted",
        allowEscapeKey: false,
        allowOutsideClick: false,
        buttonsStyling: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      await deleteQuotationDocument(deleteById)
        .then((response) => {
          loader.close();
          customSwal("File deleted successfully!");
        })
        .catch((error) => {
          loader.close();
          customError(error);
        });

      await this.getQuotationDocumentListAction(this.quotationId.id);
      this.documentDetails.documentList = this.documents;

      this.$nextTick(() => {
        this.$bvModal.show("modal-view-quote-document");
      });
    },

    updateItemCost(index) {
      const item = this.invoiceData.items[index];
      const salesPrice = parseFloat(item.cost);
      this.invoiceData.items[index].cost = parseFloat(salesPrice);
    },

    getCurrentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    // validateDiscount(index) {
    //   if (
    //     this.invoiceData.items[index].discountType === 0 &&
    //     this.invoiceData.items[index].discount > 100
    //   ) {
    //     this.$set(this.invoiceData.items[index], "discount", 100);
    //   }
    // },

    validateDiscount(index) {
      if (
        this.invoiceData.items[index].discountType === 0 &&
        this.invoiceData.items[index].discount > 100
      ) {
        this.$set(this.invoiceData.items[index], "discount", 100);
      } else if (
        this.invoiceData.items[index].discountType === 1 &&
        this.invoiceData.items[index].discount >
        this.invoiceData.items[index].cost * this.invoiceData.items[index].qty
      ) {
        this.$swal({
          title: "Error!",
          html: " Discount cannot exceed total item cost. Discount was set to equal total item cost.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        this.$set(
          this.invoiceData.items[index],
          "discount",
          this.invoiceData.items[index].cost * this.invoiceData.items[index].qty
        );
      }
    },
    ensureNotNull(index) {
      if (
        this.items[index].discount == null ||
        this.items[index].discount === ""
      ) {
        this.items[index].discount = 0;
      }
    },
    ensureMainDiscountNotNull() {
      if (this.MainDiscount == null || this.MainDiscount === "") {
        this.MainDiscount = 0;
      }
      this.formatDiscount();
    },
    formatDiscount() {
      if (this.MainDiscount) {
        this.MainDiscount = parseFloat(this.MainDiscount).toFixed(2);
      }
    },
    itemCost(cost, qty, discountType, discount) {
      cost = Number(cost);
      qty = Number(qty);
      discount = Number(discount);

      if (isNaN(cost) || isNaN(qty) || isNaN(discount)) {
        return "0.00";
      }

      let result = cost * qty;

      if (discountType == 0) {
        let discountAmount = result * (discount / 100);

        // Check if discountAmount is greater than the cost of all items
        if (discountAmount > result) {
          console.warn(
            "Discount cannot exceed total item cost. Discount was set to equal total item cost."
          );
          discountAmount = result;
        }
        result = result - discountAmount;
      } else if (discountType == 1) {
        // Check if flat discount is greater than the cost of all items
        if (discount > result) {
          console.warn(
            "Discount cannot exceed total item cost. Discount was set to equal total item cost."
          );
          discount = result;
        }
        result = result - discount;
      }
      return result.toFixed(2);
    },

    addNewItemInItemForm() {
      this.invoiceData.items.push(
        JSON.parse(JSON.stringify(this.itemFormBlankItem))
      );

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
        setTimeout(() => {
          this.$refs.form.style.overflow = null;
        }, 350);
      });
    },

    success() {
      this.$swal({
        title: "Success!",
        text: "You have successfully updated the quotation!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then(this.$router.push({ name: "quotation-list" }));
    },
    // error
    error(error) {
      this.$swal({
        title: "Error!",
        text: "Quotation not updated!" + error.response.data.message,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    removeItem(index) {
      this.invoiceData.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    async updateQuotation() {
      let isValid = await this.$refs.quote.validate();
      this.$refs.quote.validate().then((isValid) => {
        if (!isValid) {
          // Find the first invalid field
          const firstErrorField = this.$el.querySelector(".text-danger");
          console.log(firstErrorField);
          if (firstErrorField) {
            // Scroll to the first invalid field
            firstErrorField.scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "nearest",
            });
            // Set focus on the first invalid field
            firstErrorField.focus();
          }
        }
      });
      if (isValid) {
        if (this.invoiceData.items.length === 0) {
          this.$swal(
            "Error",
            "No items added! Please add items before creating a quotation.",
            "error"
          );
          return;
        } else {
          let payload = {
            id: this.id,
            leadClientId: this.leadClientId,
            salesPersonId: this.salesPersonId,
            rate: this.rate,
            dueDate: this.dueDate,
            priority: this.priority,
            notes: this.note,
            discount: this.discountTotal,
            discountType:
              this.MaindiscountType !== null
                ? String(this.MaindiscountType)
                : "0",
            status: 0,
            isActive: true,
            paymentMethod: "string",
            subTotal: this.subTotal,
            tax: this.salesTax,
            total: this.finalTotal,
            quotationitems: this.invoiceData.items.map((event) => {
              let discountValue;
              if (event.discountType === 0) {
                discountValue = event.qty * event.cost * (event.discount / 100);
              } else if (event.discountType === 1) {
                discountValue = event.discount;
              } else {
                discountValue = 0;
              }
              return {
                quotationId: this.id,
                itemId: event.value,
                id: event.singleId,
                description: event.description ? event.description : "",
                cost: event.cost,
                quantity: event.qty,
                discountType: String(event.discountType),
                discount: discountValue,
                tax: event.tax ?? 0,
                price: event.purchase,
                isActive: true,
              };
            }),
          };
          this.updateQuotationsAction(payload)
            .then(() => {
              this.success();
            })
            .catch((error) => {
              this.error(error);
            });
        }
      }
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
    customerSelected(id) {
      this.whenSelected = null;
      // this.getLeadByIDAction(id)
      //   .then((response) => {
      //     this.whenSelected = this.leadId;
      //   })
      //   .catch((error) => {
      //     this.getCustomersByIDAction(id).then((response) => {
      //       this.whenSelected = this.custId;
      //     });
      //   });
      this.getCustomersByIDAction(id)
        .then((response) => {
          this.whenSelected = this.custId;

          //console.log("selecteddddddd", this.whenSelected);

          let custcity = this.whenSelected.profile?.city?.name;
          // console.log("custcity", custcity);

          this.whenSelected.city = custcity ? custcity : "";
        })
        .catch((error) => {
          this.getLeadByIDAction(id).then((response) => {
            this.whenSelected = this.leadId;
          });
        });
    },
  },
  beforeMount() {
    this.getCustomersListAction();
    this.getLeadListAction();
    this.getSalesPersonListAction();
    this.getProductListAction(true);
  },
  async mounted() {
    this.whenSelected = null;

    if (this.CustomerList == undefined || this.CustomerList.length == 0)
      await this.getCustomersListAction();
    if (this.leadList == undefined || this.leadList.length == 0)
      await this.getLeadListAction();
    if (this.SalesPersonList == undefined || this.SalesPersonList.length == 0)
      await this.getSalesPersonListAction();
    if (this.ProductList == undefined || this.ProductList.length == 0)
      await this.getProductListAction(true);

    this.CustomerList.map((v, i) =>
      this.optionsCustomer.push({
        value: v.id,
        text: `${(v.otherName ??= v.companyName)} ${(v.surname ??= "")}`,
      })
    );
    this.leadList.map((v, i) =>
      this.optionsCustomer.push({
        value: v.id,
        text: `${(v.otherName ??= v.companyName)} ${(v.surname ??= "")}`,
      })
    );
    await this.getQuotationByIdAction(this.id).then(() => {
      this.leadClientId = this.quotationId.leadClientId;
      this.salesPersonId = this.quotationId.salesPersonId;
      this.dueDate = this.quotationId.dueDate;
      this.createdOn = this.quotationId.createdOn;

      this.priority = this.quotationId.priority;
      this.note = this.quotationId.notes;
      this.MaindiscountType = this.quotationId.discountType;

      this.intSubTotal = this.quotationId.subTotal;
      this.iniDiscountTotal = this.quotationId.discount;
      if (this.quotationId.currency == null) this.quotationId.currency = "MUR";
      this.currencySymbol = CurrencySymbols[this.quotationId.currency];

      this.MainDiscount = (
        (this.intSubTotal == 0
          ? 0
          : this.iniDiscountTotal /
          (this.intSubTotal + this.iniDiscountTotal)) * 100
      ).toFixed(2);

      let totalItemDiscount = this.quotationId.quotationItems.reduce(
        (total, item) => {
          return parseFloat(
            (parseFloat(total) + parseFloat(item.discount)).toFixed(2)
          );
        },
        0
      );

      this.invoiceData.items = this.quotationId.quotationItems.map((event) => {
        let discount = event.discount;
        if (event.discountType === 0) {
          discount = event.cost !== 0 ? (event.discount / event.cost) * 100 : 0;
        }
        return {
          value: event.itemId,
          id: `${event.itemName}`,
          name: event.itemName,
          singleId: event.id,
          // tax: event.saleTaxPercentage,
          tax: event.tax,
          cost: event.cost,
          profit: event.markUpPercentage,
          description: event.description,
          discountType: event.discountType,
          discount: discount,
          qty: event.quantity,
          purchase: event.price,
        };
      });
      this.customerSelected(this.quotationId.leadClientId);
    });

    this.SalesPersonList.map((v, i) =>
      this.optionsSalesPerson.push({
        value: v.id,
        text: `${v.firstName}` + " " + `${v.lastName}`,
      })
    );
    this.ProductList.map((v, i) => {
      if (v.type !== 4) {
        this.optionsProduct.push({
          qty: 1,
          value: v.id,
          itemTitle: `${v.name}`,
          categoryName: v.categoryName || "-", // Default to "No Category" if null
          subCategoryName: v.subCategoryName || "-", // Default to "No Subcategory" if null
          cost: v.salePrice,
          tax: v.saleTaxPercentage,
          purchase: v.purchasePrice,
          profit: v.markUpPercentage,
          description: v.description,
        });
      }
    });

    this.optionsProduct = this.optionsProduct.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.value === item.value)
    );
    this.optionsSalesPerson = fnSortingDropdown(this.optionsSalesPerson);
    this.optionsProduct = fnSortingDropdown(
      this.optionsProduct,
      "asc",
      "itemTitle"
    );
  },
  setup() {
    //const { root } = context;
    const itemFormBlankItem = {
      item: null,
      value: null,
      name: "",
      cost: 0,
      purchase: 0,
      qty: 0,
      tax: 0,
      profit: 0,
      description: "",
      discountType: 0,
      discount: 0,
    };

    const invoiceData = ref({
      id: 5037,
      client: null,

      // ? Set single Item in form for adding data
      items: [JSON.parse(JSON.stringify(itemFormBlankItem))],

      salesPerson: "",
      note: "It was a pleasure working with you and your team. We hope you will keep us in mind for future freelance projects. Thank You!",
      paymentMethod: null,
    });

    const updateItemForm = (index, val, MainDiscount, MaindiscountType) => {
      const {
        cost,
        qty,
        description,
        purchase,
        tax,
        profit,
        value,
        name,
        discount,
        discountType,
      } = val;
      invoiceData.value.items[index].cost = cost;
      invoiceData.value.items[index].qty = qty;
      invoiceData.value.items[index].name = name;
      invoiceData.value.items[index].value = value;
      invoiceData.value.items[index].tax = tax;
      invoiceData.value.items[index].profit = profit;
      invoiceData.value.items[index].purchase = purchase;
      invoiceData.value.items[index].description = description;
      invoiceData.value.items[index].discount = discount ?? MainDiscount;
      invoiceData.value.items[index].discountType =
        discountType ?? MaindiscountType;
    };
    // console.log("invoiceData", invoiceData);
    return {
      invoiceData,
      updateItemForm,
      itemFormBlankItem,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.invoice-total-wrapper {
  width: 100% !important;
  max-width: 30rem !important;
}

.invoice-add-wrapper {
  .add-new-client-header {
    padding: $options-padding-y $options-padding-x;
    color: $success;

    &:hover {
      background-color: rgba($success, 0.12);
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";

.form-item-section {
  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

#vs7__listbox {
  z-index: -1;
}

.repeater-form {
  // overflow: hidden;
  transition: 0.35s height;
}

.v-select {

  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }
  }
}
</style>
